import BannerImage from "../../../assets/images/banner-home-kids.png";
import BannerImageMobile from "../../../assets/images/banner-home-kids-mobile.png";

import {
  DesktopVersion,
  Image,
  MobileVersion,
  StyledBox,
} from "../styles/BannerStyles";

export function Banner() {
  return (
    <StyledBox
      id="banner"
      data-testid="banner"
      aria-label="Banner principal da página inicial"
    >
      <DesktopVersion>
        <Image
          src={BannerImage}
          alt="Banner principal SulAmérica Odonto Empresa"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
      </DesktopVersion>

      <MobileVersion
        data-testid="banner-mobile-decorative"
        aria-hidden="true"
      >
        <Image
          src={BannerImageMobile}
          alt=""
        />
      </MobileVersion>
    </StyledBox>
  );
}

export default Banner;